export const calculateProgress = (status, activities = [], statuses = []) => {
    let progress = 0;
  
    // ✅ Find the index of the current status in the statuses array
    const statusIndex = statuses.findIndex(s => s.name === status);
  
    if (statusIndex !== -1 && statuses.length > 1) {
      // ✅ Calculate progress dynamically based on position in the list
      progress = (statusIndex / (statuses.length - 1)) * 100;
    }
  
    // ✅ Adjust progress based on the number of open activities
    const openActivities = activities.filter(activity => activity.status !== "Completed").length;
    if (openActivities > 0) {
      progress += Math.min(openActivities * 5, 20); // Add up to 20% for open activities
    }
  
    return Math.min(progress, 100); // ✅ Ensure max progress is 100%
  };